import { DependencyList,  useCallback } from "react";

export const useIntcmp = (dependencies: DependencyList = []) => {
    return useCallback((e: any) => {
        if (e?.target?.closest('[data-intcmp]')) {
            const trackingTag = e?.target?.closest('[data-intcmp]');
            window.localStorage.setItem('intcmp', trackingTag.dataset.intcmp);
        }
    }, dependencies)
}